import { DropzoneContainer } from './molecule.dropzones.js';
import { jsx } from 'react/jsx-runtime';

function PrintContainer(props) {
  return /*#__PURE__*/jsx(DropzoneContainer, {
    taskEntryKey: props.taskEntryKey,
    dropzones: props.task.groups,
    tiles: props.task.content,
    facitType: "user-entry"
  });
}

export { PrintContainer };
//# sourceMappingURL=organism.print-container.js.map
